import storage from 'redux-persist/lib/storage';
import { persistReducer } from 'redux-persist';

export default reducers => {
  const persistedReducer = persistReducer(
    {
      key: 'confadmin',
      storage,
      whitelist: ['adminUser', 'auth'],
    },
    reducers
  );

  return persistedReducer;
};
